import React from 'react';
import { FileText, Download, ArrowRight } from 'lucide-react';
export function BidsTenders() {
  const bids = [{
    id: 'AUC/IT/01/2024',
    title: 'Supply and Installation of IT Equipment for Regional Offices',
    category: 'Goods',
    closingDate: '15 Nov 2024',
    status: 'Open'
  }, {
    id: 'AUC/HLTH/05/2024',
    title: 'Consultancy Services for Health Infrastructure Assessment',
    category: 'Services',
    closingDate: '22 Nov 2024',
    status: 'Open'
  }, {
    id: 'AUC/EDU/12/2024',
    title: 'Procurement of Educational Materials for Vocational Centers',
    category: 'Goods',
    closingDate: '30 Nov 2024',
    status: 'Open'
  }, {
    id: 'AUC/INF/08/2024',
    title: 'Construction of Solar Mini-Grids in Rural Communities',
    category: 'Works',
    closingDate: '05 Dec 2024',
    status: 'Open'
  }];
  return <section id="bids" className="py-20 bg-white" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-38">
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-39">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-au-navy mb-4" data-id="element-40">
            Current Bids & Tenders
          </h2>
          <div className="h-1 w-16 bg-au-gold mx-auto mb-6" data-id="element-41"></div>
          <p className="text-gray-600" data-id="element-42">
            The African Union Commission invites qualified and eligible bidders
            to submit proposals for the following open opportunities. All
            procurement processes adhere to strict guidelines of transparency
            and fairness.
          </p>
        </div>

        <div className="overflow-x-auto bg-white rounded-lg shadow-sm border border-gray-200 mb-8" data-id="element-43">
          <table className="w-full text-left border-collapse" data-id="element-44">
            <thead data-id="element-45">
              <tr className="bg-gray-50 border-b border-gray-200" data-id="element-46">
                <th className="py-4 px-6 font-semibold text-gray-700 text-sm uppercase tracking-wider" data-id="element-47">
                  Reference
                </th>
                <th className="py-4 px-6 font-semibold text-gray-700 text-sm uppercase tracking-wider" data-id="element-48">
                  Title
                </th>
                <th className="py-4 px-6 font-semibold text-gray-700 text-sm uppercase tracking-wider" data-id="element-49">
                  Category
                </th>
                <th className="py-4 px-6 font-semibold text-gray-700 text-sm uppercase tracking-wider" data-id="element-50">
                  Closing Date
                </th>
                <th className="py-4 px-6 font-semibold text-gray-700 text-sm uppercase tracking-wider" data-id="element-51">
                  Status
                </th>
                <th className="py-4 px-6 font-semibold text-gray-700 text-sm uppercase tracking-wider text-right" data-id="element-52">
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-53">
              {bids.map((bid, index) => <tr key={index} className="hover:bg-gray-50 transition-colors" data-id="element-54">
                  <td className="py-4 px-6 text-sm font-medium text-gray-900 whitespace-nowrap" data-id="element-55">
                    {bid.id}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-800" data-id="element-56">
                    <div className="flex items-start" data-id="element-57">
                      <FileText size={16} className="text-au-green mr-2 mt-0.5 flex-shrink-0" data-id="element-58" />
                      <span className="font-medium" data-id="element-59">{bid.title}</span>
                    </div>
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-600 whitespace-nowrap" data-id="element-60">
                    {bid.category}
                  </td>
                  <td className="py-4 px-6 text-sm text-gray-600 whitespace-nowrap" data-id="element-61">
                    {bid.closingDate}
                  </td>
                  <td className="py-4 px-6 text-sm whitespace-nowrap" data-id="element-62">
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-au-green" data-id="element-63">
                      {bid.status}
                    </span>
                  </td>
                  <td className="py-4 px-6 text-sm text-right whitespace-nowrap" data-id="element-64">
                    <button className="inline-flex items-center text-au-green hover:text-au-navy font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-au-green focus:ring-offset-2 rounded-sm" data-id="element-65">
                      <Download size={16} className="mr-1" data-id="element-66" /> Docs
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="text-center" data-id="element-67">
          <a href="#" className="inline-flex items-center justify-center bg-white border-2 border-au-green text-au-green px-6 py-3 rounded font-semibold hover:bg-au-green hover:text-white transition-colors focus:outline-none focus:ring-2 focus:ring-au-green focus:ring-offset-2" data-id="element-68">
            View All Opportunities <ArrowRight size={18} className="ml-2" data-id="element-69" />
          </a>
        </div>
      </div>
    </section>;
}